<template>
  <section id="information" class="text-center container">
    <h2 class="intro_info">
      <strong>6</strong><small>月</small><strong>16</strong><small>日より</small>
      <a href="http://www.aeoncinema.com/cinema/moriya/" class="" title="イオンシネマ守谷にて先行公" target="_blank">イオンシネマ守谷にて先行公</a>開
      <br><strong>6</strong><small>月</small><strong>30</strong><small>日より</small>
      <a href="http://qualite.musashino-k.jp/" class="" title="新宿シネマカリテ" target="_blank">新宿シネマカリテ</a><small>他</small>
      <br>全国ロードショー</h2>

      <ul class="sns_block columns is-gapless is-mobile is-centered">
        <li class="column is-narrow">
          <a href="https://www.facebook.com/namaemovie/" class="sns_block--link" title="Facebook" target="_blank"><svg class="icon icon-facebook"><use xlink:href="#icon-facebook"></use></svg></a>
        </li>
        <li class="column is-narrow">
          <a href="https://twitter.com/namae_ibaraki" class="sns_block--link" title="Twitter" target="_blank"><svg class="icon icon-twitter"><use xlink:href="#icon-twitter"></use></svg></a>
        </li>
        <li class="column is-narrow">
          <a href="https://www.instagram.com/the_name_2018/" class="sns_block--link" title="Instagram" target="_blank"><svg class="icon icon-instagram"><use xlink:href="#icon-instagram"></use></svg></a>
        </li>
      </ul>
    <div class="main--inner">
      <p class="text__large">津田寛治 駒井 蓮</p>

      <p class="text">勧修寺保都 松本穂香 内田理央 池田 良 <br class="is-hidden-tablet">木嶋のりこ 金澤美穂</p>

      <p class="text__small">比嘉梨乃 真広佳奈 小槙まこ 戸畑 心</p>
      <p class="text__small">柿本朱里 アベラヒデノブ 田山由起</p>
      <p class="text__small">竹下かおり 信國輝彦 松林慎司 稲荷卓央</p>

      <p class="text">波岡一喜 川瀬陽太 <br class="is-hidden-tablet">田村泰二郎 西山繭子</p>
      <p class="text">筒井真理子</p>

      <p class="text__large">監督:戸田彬弘</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'information',
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Information.vue